import "react-dates/lib/css/_datepicker.css";
import "../scss/style.scss";

import { AppProps } from "next/app";
import { Provider } from "react-redux";

import { useStore } from "../store";

function MyApp(props: AppProps) {
  const { Component, pageProps } = props;
  const store = useStore(pageProps.initialReduxState);

  return (
    <Provider store={store}>
      <Component {...pageProps} />
    </Provider>
  );
}

export default MyApp;
